<template>
    <b-form @submit.prevent="getKKMs(formData)">
        <b-form-group :label="$t('general.iin')">
            <b-form-input v-model="formData.dealerIin" :disabled="!!Object.keys(initialData).length"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('kkm.registration')">
            <b-form-input v-model="formData.registrationNumber"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('kkm.factoryNum')">
            <b-form-input v-model="formData.factoryNumber"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('kkm.pointTitle')">
            <b-form-input v-model="formData.salePointTitle"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('kkm.pointAddress')">
            <b-form-input v-model="formData.address"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('kkm.inspectionName')">
            <multiselect v-model="selectedTaxOrg" :options="taxOrgList" @input="taxOrgSelected"
                        :close-on-select="true" :hide-selected="true" :showNoResults="false"
                        :custom-label="taxOrgLabel" :placeholder="$t('general.select')"  :disabled="isInspector" :select-label="''">
                <template slot="noOptions">
                    <span>
                        {{ $t('general.enterValue' )}}
                    </span>
                </template>
            </multiselect>
        </b-form-group>
        <b-form-group :label="$t('kkm.status')">
            <b-form-select v-model="formData.status" :options="statusOptions" />
        </b-form-group>
        <b-form-row class="mx-0">
            <b-button type="submit" variant="success" class="ml-auto" :disabled="isDisabled">
                <magnify-icon title="" />&nbsp;{{ $t('general.search') }}
            </b-button>
        </b-form-row>
    </b-form>
</template>

<script>
/* eslint-disable */

export default {
    name: 'searchKkmForm',
    props: {
        fetch: Function,
        taxOrgList: Array,
        initialData: Object,
        offset: Number,
        pageSize: Number,
        setOffset: Function
    },
    mounted () {
        this.formData.dealerIin = this.initialData ? this.initialData.iin : ''
    },
    data () {
        return {
            selectedTaxOrg: null,
            formData: {
                dealerId: this.$route.params.id,
                dealerIin: '',
                registrationNumber: '',
                factoryNumber: '',
                salePointTitle: '',
                address: '',
                taxName: '',
                taxCode: '',
                status: '',
                offset: this.offset,
                pageSize: this.pageSize
            }
        }
    },
    computed: {
        isDisabled() {
            return this.$store.getters.isLoading;
        },
        isInspector() {
            return this.$store.getters.getUserRole === this.$appConfig.role.inspector;
        },
        isDealer() {
            return this.$store.getters.getUserRole === this.$appConfig.role.dealer;
        },
        statusOptions() {
            return [
                { value: null, text: this.$t('general.select') },
                { value: 'CREATED', text: this.$t('kkm.statusShortName.CREATED') },
                { value: 'READY', text: this.$t('kkm.statusShortName.READY') },
                { value: 'WAIT_OFD', text: this.$t('kkm.statusShortName.WAIT_OFD') },
                { value: 'STOP', text: this.$t('kkm.statusShortName.STOP') },
                { value: 'CLOSED', text: this.$t('kkm.statusShortName.CLOSED') }
            ]
        }
    },
    watch: {
        initialData(dealer) {
            this.formData.dealerIin = dealer.iin;
        },
        offset(newValue) {
            this.formData.offset = newValue;
            this.fetch(this.formData);
        }
    },
    methods: {
        taxOrgSelected(value) {
            this.formData.taxName = value ? value.name : null
            this.formData.taxCode = value ? value.code : null
        },
        taxOrgLabel: function ({ code, name }) {
            return `${code} - ${name}`
        },
        getKKMs: function (formData) {
            if (this.offset !== 0) {
                this.setOffset(0)
            } else {
                this.fetch(formData)
            }
        }
    }
}
</script>
